import { GsFormSchema } from '../../../components';
import { borderRadiusSchemaFields } from './../basics';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { HORIZONTAL_ALIGNMENT_SCHEMA } from './alignment.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the video component form.
 * Defines the fields to display for the form.
 */
export const VACANCY_DETAIL_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    ...HORIZONTAL_ALIGNMENT_SCHEMA,
    {
      formControlName: 'showIssueDate',
      groupingName: 'components.vacancyDetail.schema.display',
      label: 'components.vacancyDetail.schema.showIssueDate',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showMetaInfo',
      groupingName: 'components.vacancyDetail.schema.display',
      label: 'components.vacancyDetail.schema.showMetaInfo',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showPictures',
      groupingName: 'components.vacancyDetail.schema.display',
      label: 'components.vacancyDetail.schema.showPictures',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showAttachments',
      groupingName: 'components.vacancyDetail.schema.display',
      label: 'components.vacancyDetail.schema.showAttachments',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showLocationIcon',
      groupingName: 'components.vacancyDetail.schema.icons',
      label: 'components.vacancyDetail.schema.showLocationIcon',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showEmploymentTypeIcon',
      groupingName: 'components.vacancyDetail.schema.icons',
      label: 'components.vacancyDetail.schema.showEmploymentTypeIcon',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showDepartmentIcon',
      groupingName: 'components.vacancyDetail.schema.icons',
      label: 'components.vacancyDetail.schema.showDepartmentIcon',
      type: 'checkbox',
      default: true
    },
    ...borderRadiusSchemaFields('', undefined, false, undefined, 'schema.imageRadius')
  ]
};
